// extracted by mini-css-extract-plugin
module.exports = {"label":"VehicleListTabContent_label___FCE2","pulsatingCircle":"VehicleListTabContent_pulsatingCircle__dBkMD"};